const signals = [
  { icon: 'ri-rocket-2-line', title: 'Компания быстро растёт', desc: 'Каждый месяц приходят новые сотрудники, и существующая система обучения не справляется с нагрузкой.' },
  { icon: 'ri-user-unfollow-line', title: 'Высокая текучесть', desc: 'Сотрудники уходят, не видя перспектив развития. Нет системы удержания через обучение и карьерный рост.' },
  { icon: 'ri-group-line', title: 'Много новичков', desc: 'Адаптация занимает слишком много времени, нет стандартов ввода в должность и наставничества.' },
  { icon: 'ri-building-line', title: 'Несколько филиалов', desc: 'В разных офисах и городах работают по-разному, нет единых стандартов и подходов к обучению.' },
  { icon: 'ri-file-copy-line', title: 'Нет единых стандартов', desc: 'Каждый руководитель учит «как умеет». Качество работы непредсказуемо.' },
  { icon: 'ri-user-received-line', title: 'Зависимость от отдельных сотрудников', desc: 'Ключевые знания хранятся в головах 2-3 человек. Если они уйдут — бизнес встанет.' },
  { icon: 'ri-puzzle-line', title: 'Сложный продукт', desc: 'Сотрудникам требуется 3-6 месяцев, чтобы разобраться в продукте. Нет системного обучения.' },
  { icon: 'ri-shopping-bag-3-line', title: 'Большой отдел продаж', desc: 'Менеджеры работают по-разному, конверсия непредсказуема. Нет академии продаж.' },
  { icon: 'ri-user-star-line', title: 'Новые руководители', desc: 'Сотрудников повышают, но не обучают управлять. Они совершают типичные ошибки руководителей.' },
  { icon: 'ri-global-line', title: 'Масштабирование бизнеса', desc: 'Компания планирует рост в 2-3 раза. Без системы обучения масштабирование приведёт к хаосу.' },
];

export default function WhenNeeded() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Когда компании нужна корпоративная академия
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Если вы узнали свою компанию хотя бы в двух пунктах — пора создавать систему корпоративного обучения
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {signals.map((s, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-200 hover:border-teal-300 hover:shadow-md transition-all group">
              <div className="w-11 h-11 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${s.icon} text-lg text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{s.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}